<p-toast></p-toast>
<p-confirmDialog #cd [style]="{width: '50vw'}">
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
        <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
    </ng-template>
</p-confirmDialog>
<h2 style="text-align: center;">Enfermera</h2>
<div *ngIf="enfermera" class="container-ficha">
    <p-accordion [activeIndex]="0">
        <p-accordionTab header="Enfermera Perfil">
            <section>
                <div class="formgrid grid">
                    <div class="field col-12 md:col-4">
                        <label for="serie">Nombre </label>
                        <article
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            {{enfermera.nom_enfermera | uppercase}}</article>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label for="serie">Telefono Movil </label>
                        <article
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            {{enfermera.usuario.telefonoMovil ? enfermera.usuario.telefonoMovil : 'Sin información'}}
                        </article>
                    </div>
                    <div class="field col-12 md:col-4"></div>
                    <div class="field col-12 md:col-8">

                        <label for="serie">Supervisor</label>
                        <article
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
                            {{enfermera.supervisor ? enfermera.supervisor.nom_supervisor : 'Sin supervisor asignado' |
                            uppercase }}</article>

                    </div>
                </div>
            </section>
        </p-accordionTab>
        <p-accordionTab header="Casos Clinicos">
            <section *ngIf="enfermera">
                <p-toolbar styleClass="mb-4 gap-2">
                    <ng-template pTemplate="left">
                        <form id="enf-productividad-add-frm" [formGroup]="productividadEnfermeraForm">
                            <div class="formgrid grid">
                                <div class="field col">
                                    <p-calendar id="fechainicio" formControlName="fechaInicio" dateFormat="dd/mm/yy"
                                        placeholder="Ingrese la fecha inicial" class="w-full" />
                                </div>
                                <div class="field col">
                                    <p-calendar id="fechafin" formControlName="fechaFin" dateFormat="dd/mm/yy"
                                        placeholder="Ingrese la fecha final" class="w-full" />
                                </div>
                            </div>
                        </form>

                    </ng-template>

                    <ng-template pTemplate="right">
                        <button pButton pRipple label="Reporte de productividad" icon="pi pi-file"
                            class="mr-2 inline-block" (click)="exportPDF()"
                            [disabled]="productividadEnfermeraForm.invalid"></button>
                        <button pButton pRipple [label]="'Excel'" icon="pi pi-file-excel" class="p-button-success"
                            (click)="exportExcel()"></button>

                    </ng-template>
                </p-toolbar>
                <p-table [value]="casosClinicos" [tableStyle]="{ 'min-width': '50rem' }">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Fecha</th>
                            <th>Caso Clinico</th>
                            <th>Paciente</th>
                            <th>Parte cuerpo</th>
                            <th>Hospital</th>
                            <th>No. Productos</th>
                            <th>No. Documentos</th>
                            <th>Status</th>
                            <th>Puntos</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-casoclinico>
                        <tr>
                            <td>{{casoclinico.fecha | date: 'dd/MM/yyyy'}}</td>
                            <td>
                                <a [routerLink]="['/supervisor/casoclinico', casoclinico.id]">{{casoclinico.serie}}</a>
                            </td>
                            <td>{{casoclinico.paciente}}</td>
                            <td>{{casoclinico.nomCuerpo}}</td>
                            <td>{{casoclinico.nomHospital}}</td>
                            <td>{{casoclinico?.productos?.length}}</td>
                            <td>{{casoclinico?.documentos?.length}}</td>
                            <td>
                                <span
                                    [ngClass]="{'solicitud': casoclinico.status_canje === 1,
                                                                            'enproceso': casoclinico.status_canje === 2, 
                                                                            'pagado': casoclinico.status_canje === 3, 
                                                                            'cancelado': casoclinico.status_canje === 4}">
                                    {{getCanje(casoclinico.status_canje)}}
                                </span>
                            </td>
                            <td>{{casoclinico.e_puntos}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="9" class="text-center p-4">
                                <div class="flex flex-column align-items-center">
                                    <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                                    <span class="text-600 mt-2">Sin Casos Clinicos</span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            No. Registros: {{totalItemsCasosClinicos}}, Total paginas {{totalPaginasCasosClinicos}}
                        </div>
                    </ng-template>
                </p-table>
                <div class="card flex justify-content-center">
                    <p-paginator (onPageChange)="onPageChangeCasosClinicos($event)"
                        [first]="currentPageCasosClinicos.first" [rows]="currentPageCasosClinicos.rows"
                        [totalRecords]="totalItemsCasosClinicos"></p-paginator>
                </div>
            </section>
        </p-accordionTab>
        <p-accordionTab header="Medicos">
            <section *ngIf="enfermera">
                <p-toolbar styleClass="mb-2 gap-2">
                    <div class="p-toolbar-group-start">

                        <form [formGroup]="medicoForm" (ngSubmit)="onSubmit()">
                            <div class="formgroup-inline">
                                <div class="field">
                                    <p-dropdown [options]="catalogoMedicos" optionLabel="nom_medico" [filter]="true"
                                        filterBy="nom_medico" [showClear]="true" formControlName="medico"
                                        [emptyMessage]="'Sin registros'" [emptyFilterMessage]="'Sin resultados'"
                                        placeholder="Seleccione una medico"></p-dropdown>
                                </div>
                                <p-button icon="pi pi-user-plus" [disabled]="medicoForm.invalid" [type]="'submit'"
                                    styleClass="p-button-rounded p-button-info p-button-text p-button-raised"></p-button>
                            </div>
                        </form>

                    </div>
                    <div class="p-toolbar-group-end">

                    </div>
                </p-toolbar>
                <p-table [value]="medicos" [tableStyle]="{ 'min-width': '50rem' }">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Medico</th>
                            <th>Especialidad</th>
                            <th>Telefono Movil</th>
                            <th>Accion</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-medico>
                        <tr>
                            <td>{{medico.nom_medico | uppercase}}</td>
                            <td>{{medico.nomEspecialidad}}</td>
                            <td>{{medico.telefonoMovil}}</td>
                            <td><p-button icon="pi pi-user-minus" (onClick)="eliminarMedico(medico.id)"
                                    styleClass="p-button-rounded p-button-danger p-button-text p-button-sm"></p-button>
                            </td>

                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="3">
                                Sin Medicos
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            No. Registros: {{totalItemsMedicos}}, Total paginas {{totalPaginasMedicos}}
                        </div>
                    </ng-template>
                </p-table>
                <div class="card flex justify-content-center">
                    <p-paginator (onPageChange)="onPageChangeMedicos($event)" [first]="currentPageMedicos.first"
                        [rows]="currentPageMedicos.rows" [totalRecords]="totalItemsMedicos"></p-paginator>
                </div>
            </section>
        </p-accordionTab>
        <p-accordionTab header="Canjes">
            <section *ngIf="enfermera">
                <p-table [value]="canjes" [tableStyle]="{ 'min-width': '50rem' }">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Fecha Solicitud</th>
                            <th>Cantidad</th>
                            <th>Status</th>
                            <th colspan="2">Acciones</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-canje>
                        <tr>
                            <td>{{canje.fechaInicio | date:'dd/MM/yyyy'}}</td>
                            <td>{{canje.redimir}}</td>
                            <td><span
                                    [ngClass]="{'solicitud': canje.status === 1,'rechazado': canje.status === 2, 'procesado': canje.status === 3, 'cancelado': canje.status === 4}">{{getCanje(canje.status)}}
                                </span>
                            </td>

                            <td>
                                <a [routerLink]="['../../vista/canje', canje.id]"><i class="pi pi-eye"
                                        style="color: slateblue"></i></a>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td colspan="5" class="text-center p-4">
                                <div class="flex flex-column align-items-center">
                                    <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                                    <span class="text-600 mt-2">No se encontraron canjes</span>
                                </div>
                            </td>
                        </tr>>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            <p>No. Registros: {{totalItemsCanjes}}, Total paginas {{totalPaginasCanjes}}</p>
                            <p>Cantidad de canje pagados:{{canjesPagados}}</p>
                        </div>
                    </ng-template>
                </p-table>
                <div class="card flex justify-content-center">
                    <p-paginator (onPageChange)="onPageChangeCanjes($event)" [first]="currentPageCanjes.first"
                        [rows]="currentPageCanjes.rows" [totalRecords]="totalItemsCanjes"></p-paginator>
                </div>
            </section>
        </p-accordionTab>
    </p-accordion>
</div>